<template>
  <div>
    <b-row>
      <b-col>
        <vx-card title="">
          <b-row>
            <b-col cols="4">
              <HepsiLojistikComponent
                :program="pazaryer"
                ref="secilenSiparisler"
              />
            </b-col>
          </b-row>
        </vx-card>
      </b-col>
    </b-row>
    <ag-grid-vue
      style="width: 100%; height: 400px; margin-top: 25px"
      class="ag-theme-alpine"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="list"
      :localeText="localeText"
      @grid-ready="onGridReady"
      @first-data-rendered="onFirstDataRendered"
      @selection-changed="onSelectionChanged"
      :rowSelection="rowSelection"
      :suppressRowClickSelection="true"
    >
    </ag-grid-vue>
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import HepsiLojistikComponent from "../components/uzum-components/pazaryeri-components/HepsiLojistikComponent.vue";
export default {
  data() {
    return {
      lojistikList: Store.state.uzum.lojistikList,
      pazaryer: "Hepsiburada",
      list: null,
      rowSelection: null,
      localeText: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
    };
  },
  components: {
    AgGridVue,
    HepsiLojistikComponent,
  },
  created() {
    console.log(this.lojistikList);
    this.rowSelection = "multiple";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.siparisListesi();
  },
  methods: {
    siparisListesi() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { pazaryeri: "Hepsiburada", token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.siparisListele(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.siparisListeleResult);
          vm.list = vm.veriler;
          console.log(vm.veriler);
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenSiparisler = selectedRows;
      this.$refs.secilenSiparisler.sepetSecilen(selectedRows);
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        width: 50,
      },
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "invoiceFirstName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo No",
        field: "cargoTrackingNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Tutar",
        field: "grossAmount",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş Adetleri",
        field: "siparisAdetleri",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>